// SignUpCTA.tsx
import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Button from "@mui/material/Button";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { getLoginCookieAndSession } from "../../utils";
import { useStripeAccountStatus } from "../../hooks/useStripeAccountStatus";
import { DrawerModal } from "./DrawerModal";
import Login from "./Login";

const SignUpSection: React.FC = () => {
  const navigate = useNavigate();
  const { sellRoute } = useStripeAccountStatus();
  const [isSellModalOpen, setSellModalOpen] = useState(false);

  const handleStartSellingClick = () => {
    if (getLoginCookieAndSession()) {
      navigate(sellRoute);
    } else {
      setSellModalOpen(true);
    }
  };

  const closeSellModal = () => setSellModalOpen(false);

  return (
    <>
      <div
        style={{
          backgroundColor: "#fff4e5",
          padding: "20px",
          borderRadius: "16px",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <Alert
          severity="warning"
          icon={<InfoOutlinedIcon />}
          style={{ marginBottom: "0px", borderRadius: "16px" }}
        >
          Ready to sell your toys hassle-free? Check out FiddlePiddle.com. No
          listing or joining fees, just sign up with your email and password,
          and start earning instantly! Say goodbye to Amazon and eBay
          frustrations. Give it a go, it's that easy!
        </Alert>
        <center style={{ marginTop: "-20px" }}>
          <div style={{}}>
            <h4>Free to Join • Free to List • Instant Payout*</h4>
            <Button
              variant="contained"
              color="primary"
              onClick={handleStartSellingClick}
              style={{
                borderRadius: "20px",
                width: "200px",
                color: "white",
                lineHeight: "unset",
              }}
              sx={{ marginTop: "-10px" }}
            >
              Start Selling Now
            </Button>
          </div>
        </center>
      </div>
      <div style={{ marginBottom: 20 }}>
        <Footer />
      </div>

      <DrawerModal
        isOpen={isSellModalOpen}
        onClose={closeSellModal}
        anchor="bottom"
        onOpen={handleStartSellingClick}
      >
        <Login openFormFrom={"Seller"} />
      </DrawerModal>
    </>
  );
};

export default SignUpSection;
